import { createContext, useContext } from 'react';

const ButtonSetContext = /*#__PURE__*/createContext({});
const ButtonSetProvider = ButtonSetContext.Provider;
const useButtonSetContext = () => {
  return useContext(ButtonSetContext);
};

export { ButtonSetProvider, useButtonSetContext };
